export const removeLastUrl = (str: string) => {
  return str.replace(/(http(s)?:\/\/[a-zA-Z0-9-.!'()*;/?:@&=+$,%#]+)$/gi, '');
};
